import styled from 'styled-components';
import React from "react";

const Trusts = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  @media only screen and (max-width: 700px) {
    flex-direction: column;
    text-align: center;
  }
`;

const Trust = styled.div`
  padding: 30px;
`;

const Trusts1 = styled.div`
  display: flex;
  padding-left: 50px;
  padding-right: 50px;
  justify-content: space-around;
  flex-wrap: wrap;
  @media only screen and (max-width: 700px) {
    padding: 0px;
    flex-direction: column;
    text-align: center;
  }
`;

export default function TrustsComp() {
  return (
    <>
      <Trusts style={{ marginTop: '20px' }}>
        <Trust>
          <img src="//brands/landing/alibaba.png" />
        </Trust>
        <Trust>
          <img src="//brands/landing/swiggy.png" />
        </Trust>
        <Trust>
          <img src="//brands/landing/shareit.png" />
        </Trust>
        <Trust>
          <img src="//brands/landing/sharechat.png" />
        </Trust>
        <Trust>
          <img src="//brands/landing/paytm.png" />
        </Trust>
      </Trusts>
      <Trusts1>
        <Trust>
          <img style={{ height: '40px' }} src="/brands/bookmyshow.png" />
        </Trust>
        <Trust>
          <img style={{ height: '30px' }} src="/brands/vivo.png" />
        </Trust>
        <Trust>
          <img style={{ height: '30px' }} src="/brands/uber.png" />
        </Trust>
        <Trust>
          <img style={{ height: '40px' }} src="/brands/dailyhunt.png" />
        </Trust>
      </Trusts1>
    </>
  );
}
